// extracted by mini-css-extract-plugin
module.exports = {"serviceSection":"service-section-module--service-section--1t-uX"};